import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/theme.css'
import { initTheme } from './lib/theme'

// Apply the persisted theme before React paints, so there is no flash of the
// wrong mode on load.
initTheme()

const el = document.getElementById('root')
if (!el) throw new Error('root element not found')

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
